export { default } from "./ChangeScale";
